// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* our_student.css */

.our-student-page {
  --os-type-heading: clamp(2rem, 2.8vw, 2.6rem);
  --os-type-subheading: 1.2rem;
  --os-type-card-heading: 1.1rem;
  --os-type-body: 1rem;
  --os-type-label: 0.88rem;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #ece4ed;
  color: #0d121b;
  font-family: "Lexend", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

.os-container {
  width: min(1100px, 100% - 48px);
  margin: 0 auto;
}

/* ---------- HERO ---------- */
.os-hero {
  position: relative;
  width: 100%;
  padding: 80px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.os-hero__overlay {
  position: absolute;
  inset: 0;
  background: #370b3b;
  opacity: 0.9;
  z-index: 1;
}

.os-hero__content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.os-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  margin-bottom: 18px;
}

.os-pill__icon {
  color: #f59e0b;
  font-size: 18px;
}

.os-pill__text {
  color: #ece4ed;
  font-size: var(--os-type-label);
  font-weight: 500;
  letter-spacing: 0.4px;
}

.os-hero__title {
  color: #ffffff;
  font-weight: 900;
  line-height: 1.05;
  letter-spacing: -0.03em;
  font-size: clamp(34px, 4vw, 60px);
  margin: 0 0 10px;
}

.os-hero__subtitle {
  color: rgba(219, 234, 254, 1);
  font-size: clamp(16px, 1.6vw, 20px);
  line-height: 1.5;
  max-width: 720px;
  margin: 0;
}

/* ---------- STATS ---------- */
.os-stats-wrap {
  position: relative;
  margin-top: -40px;
  padding-bottom: 12px;
}

.os-stats {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(13, 18, 27, 0.12);
  padding: 22px 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  overflow: hidden;
}

.os-stats--single {
  grid-template-columns: 1fr;
}

.os-stat {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.os-stats--single .os-stat {
  max-width: 380px;
  margin: 0 auto;
}

.os-stat--mid {
  border-left: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
}

.os-stat__iconWrap {
  width: 46px;
  height: 46px;
  border-radius: 9999px;
  display: grid;
  place-items: center;
  background: #eff6ff;
  margin-bottom: 10px;
}

.os-stat__icon {
  color: #370b3b;
  font-size: 28px;
}

.os-stat__value {
  font-weight: 900;
  font-size: 36px;
  margin: 0;
}

.os-stat__label {
  color: #6b7280;
  font-size: var(--os-type-label);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-top: 4px;
}

/* ---------- SECTION HEADINGS ---------- */
.os-h2 {
  font-size: var(--os-type-heading);
  font-weight: 800;
  letter-spacing: -0.015em;
  margin: 0 0 6px;
}

.os-h2--big {
  font-size: clamp(28px, 2.6vw, 40px);
}

.os-muted {
  color: #6b7280;
  margin: 0;
}

.os-kicker {
  color: #370b3b;
  font-size: var(--os-type-label);
  font-weight: 900;
  letter-spacing: 0.14em;
}

/* ---------- PLACEHOLDER (for future images) ---------- */
.os-placeholder {
  background: #ece4ed;
  border: 1px dashed #370b3b;
  position: relative;
}

.os-placeholder__center {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  gap: 6px;
  color: #370b3b;
  font-weight: 800;
  opacity: 0.85;
}

.os-placeholder__center span.material-symbols-outlined {
  font-size: 28px;
}

/* ---------- TOP PERFORMERS ---------- */
.os-performers {
  padding: 58px 0 30px;
  background: #ece4ed;
}

.os-performers--muted {
  opacity: 0.42;
  filter: grayscale(0.15);
  pointer-events: none;
}

.os-performers__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 26px;
}

.os-tabs {
  display: inline-flex;
  padding: 4px;
  background: #d6c3d9;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(13, 18, 27, 0.04);
}

.os-tab {
  border: 0;
  background: transparent;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 650;
  color: #6b7280;
  cursor: pointer;
  transition: all 160ms ease;
}

.os-tab:hover {
  color: #370b3b;
}

.os-tab.is-active {
  background: #370b3b;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(15, 73, 189, 0.25);
}

.os-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.os-card {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eef2f7;
  box-shadow: 0 2px 10px rgba(13, 18, 27, 0.05);
  transition: transform 200ms ease, box-shadow 200ms ease;
}

.os-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);
}

.os-card--gold {
  border: 1px solid #fcd34d;
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.15);
}

.os-card__badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px 10px;
  font-size: 0.85rem;
  font-weight: 800;
  color: #ffffff;
  border-bottom-left-radius: 10px;
  z-index: 2;
}

.os-card__badge.is-primary {
  background: #370b3b;
}

.os-card__badge.is-accent {
  background: #f59e0b;
}

.os-card__imgWrap {
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.os-card__body {
  padding: 14px 14px 16px;
  text-align: center;
}

.os-card__name {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
}

.os-card__meta {
  margin-top: 4px;
  color: #370b3b;
  font-weight: 700;
  font-size: var(--os-type-body);
}

.os-divider {
  width: 100%;
  height: 1px;
  background: #eef2f7;
  margin: 12px 0;
}

.os-card__tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #f59e0b;
}

.os-star {
  font-size: 16px;
}

.os-card__tagText {
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: #6b7280;
  text-transform: uppercase;
}

.os-center {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.os-linkBtn {
  border: 0;
  background: transparent;
  color: #370b3b;
  font-weight: 800;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: gap 180ms ease;
}

.os-linkBtn:hover {
  gap: 12px;
}

.os-linkBtn__icon {
  font-size: 18px;
}

/* ---------- NEW: VIDEOS ROW SECTION ---------- */
.os-videoRow {
  padding: 34px 0 70px;
  background: #ece4ed;
}

.os-videoRow__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 18px;
}

.os-videoRow__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.os-videoTile {
  border-radius: 14px;
  overflow: hidden;
  background: #0b1220;
  box-shadow: 0 14px 26px rgba(13, 18, 27, 0.12);
  cursor: pointer;
  height: 280px;
  position: relative;
}

.os-videoTile__iframeWrap {
  width: 100%;
  height: 100%;
}

.os-ytFrame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.os-videoTile__caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 14px;
  color: #fff;
  font-weight: 700;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0));
}

/* ---------- Restored: Previously Mentored Students ---------- */
.os-mentored {
  background: #e0d8e2;
  padding: 70px 0 84px;
  border-top: 1px solid #eef2f7;
}

.os-mentored--muted {
  opacity: 1;
}

.os-mentored__title {
  text-align: center;
  margin-bottom: 28px;
}

.os-mentored__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.os-mentoredCard {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #eef2f7;
  box-shadow: 0 2px 12px rgba(13, 18, 27, 0.06);
  overflow: hidden;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.os-mentoredCard:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);
}

.os-mentoredCard__img {
  display: block;
  width: 100%;
  height: 210px;
  object-fit: contain;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  background: #f8fafc;
}

.os-mentoredCard__text {
  display: block;
  width: 100%;
  height: 140px;
  object-fit: contain;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  border-top: 1px solid rgba(15, 73, 189, 0.12);
  background: #f8fafc;
}

.os-mentoredCard__text--empty {
  transform: none;
}

.os-mentoredCard__meta {
  padding: 12px 14px 14px;
  text-align: center;
  background: #fff;
  position: relative;
  z-index: 1;
}

.os-mentoredCard__name {
  font-weight: 900;
  font-size: 22px;
  line-height: 1.25;
  color: #111827;
}

.os-mentoredCard__sub {
  margin-top: 4px;
  font-size: 0.95rem;
  color: #6b7280;
}

/* ---------- NEW: You Will Be the Next ---------- */
.os-next {
  background: #e0d8e2;
  padding: 70px 0 84px;
  border-top: 1px solid #eef2f7;
}

.os-next__title {
  text-align: center;
  margin-bottom: 28px;
}

.os-next .os-kicker {
  color: #5b1a65;
  letter-spacing: 0.14em;
}

.os-next .os-h2 {
  color: #2a0d33;
}

.os-next__line1 {
  color: #370b3b !important;
}

.os-next__word-next {
  color: red;
}

.os-next__tagline {
  margin: 10px 0 0;
  font-size: 22px;
  font-weight: 900;
  color: #370b3b;
}

.os-next__accent1 {
  color: red;
}

.os-next__accent2 {
  color: #370b3b;
}

.os-next__imageWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.os-next__image {
  width: min(300px, 90vw);
  height: auto;
  display: block;
  border-radius: 14px;
  box-shadow: 0 14px 32px rgba(13, 18, 27, 0.14);
}

/* ---------- ALUMNI ---------- */
.os-alumni {
  background: #f8f9fc;
  border-top: 1px solid #e5e7eb;
  padding: 56px 0;
}

.os-alumni__inner {
  text-align: center;
}

.os-alumni__title {
  margin: 0 0 20px;
  color: #9ca3af;
  font-size: var(--os-type-label);
  font-weight: 900;
  letter-spacing: 0.16em;
}

.os-alumni__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  align-items: center;
  justify-content: center;
  opacity: 0.75;
  filter: grayscale(1);
  transition: filter 220ms ease, opacity 220ms ease;
}

.os-alumni__grid:hover {
  filter: grayscale(0);
  opacity: 1;
}

.os-alumni__pill {
  height: 46px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eef2f7;
  display: grid;
  place-items: center;
  font-weight: 800;
  color: #6b7280;
  box-shadow: 0 1px 8px rgba(13, 18, 27, 0.05);
}

/* ---------- CTA ---------- */
.os-cta {
  position: relative;
  background: #370b3b;
  padding: 76px 0;
  overflow: hidden;
}

.os-cta__shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 9999px;
}

.os-cta__shape--tr {
  width: 260px;
  height: 260px;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.os-cta__shape--bl {
  width: 380px;
  height: 380px;
  bottom: 0;
  left: 0;
  transform: translate(-50%, 50%);
}

.os-cta__inner {
  position: relative;
  z-index: 1;
  text-align: center;
  width: min(800px, 100% - 48px);
}

.os-cta__title {
  color: #fff;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: clamp(28px, 4vw, 52px);
  margin: 0 0 14px;
}

.os-cta__sub {
  color: rgba(219, 234, 254, 1);
  font-size: 18px;
  line-height: 1.6;
  margin: 0 auto 22px;
  max-width: 660px;
}

.os-cta__btns {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.os-btn {
  border: 0;
  padding: 14px 22px;
  border-radius: 10px;
  font-weight: 900;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.os-btn--white {
  background: #ffffff;
  color: #370b3b;
  box-shadow: 0 14px 24px rgba(13, 18, 27, 0.18);
}

.os-btn--white:hover {
  background: #f3f4f6;
  color: #f59e0b;
  transform: translateY(-2px);
}

.os-btn--outline {
  background: transparent;
  border: 2px solid #ffffff;
  color: #ffffff;
}

.os-btn--outline:hover {
  color: #f59e0b;
}

/* ---------- Responsive ---------- */
@media (max-width: 1024px) {
  .os-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .os-videoRow__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .os-videoTile {
    height: 260px;
  }

  .os-mentored__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .os-next__image {
    width: min(420px, 88vw);
  }

  .os-alumni__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 820px) {
  .os-performers__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .os-stat--mid {
    border-left: 0;
    border-right: 0;
  }

  .os-stats {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .os-stat {
    border-top: 1px solid #e5e7eb;
  }

  .os-stat:first-child {
    border-top: 0;
  }
}

@media (max-width: 520px) {
  .os-container {
    width: min(1100px, 100% - 28px);
  }

  .os-cards {
    grid-template-columns: 1fr;
  }

  .os-videoRow__grid {
    grid-template-columns: 1fr;
  }

  .os-videoTile {
    height: 240px;
  }

  .os-mentored__grid {
    grid-template-columns: 1fr;
  }

  .os-next__tagline {
    font-size: 16px;
  }

  .os-next__image {
    width: min(340px, 88vw);
  }

  .os-alumni__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===== Featured centered video (16:9) ===== */
.os-featuredVideo {
  padding: 32px 0 8px;
}

.os-featuredVideo__frameWrap {
  max-width: 800px;
  margin: 0 auto;
  aspect-ratio: 16 / 9;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);
  background: #000;
}

.os-featuredVideo__frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

@media (max-width: 640px) {
  .os-featuredVideo {
    padding: 20px 0 4px;
  }
  .os-featuredVideo__frameWrap {
    border-radius: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/testimonials/our_student.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,6CAA6C;EAC7C,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oFAAoF;AACtF;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,4BAA4B;EAC5B,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,MAAM;EACN,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* our_student.css */\r\n\r\n.our-student-page {\r\n  --os-type-heading: clamp(2rem, 2.8vw, 2.6rem);\r\n  --os-type-subheading: 1.2rem;\r\n  --os-type-card-heading: 1.1rem;\r\n  --os-type-body: 1rem;\r\n  --os-type-label: 0.88rem;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  overflow-x: hidden;\r\n  background: #ece4ed;\r\n  color: #0d121b;\r\n  font-family: \"Lexend\", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\r\n}\r\n\r\n.os-container {\r\n  width: min(1100px, 100% - 48px);\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ---------- HERO ---------- */\r\n.os-hero {\r\n  position: relative;\r\n  width: 100%;\r\n  padding: 80px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n.os-hero__overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: #370b3b;\r\n  opacity: 0.9;\r\n  z-index: 1;\r\n}\r\n\r\n.os-hero__content {\r\n  position: relative;\r\n  z-index: 2;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.os-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 14px;\r\n  border-radius: 9999px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(8px);\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.os-pill__icon {\r\n  color: #f59e0b;\r\n  font-size: 18px;\r\n}\r\n\r\n.os-pill__text {\r\n  color: #ece4ed;\r\n  font-size: var(--os-type-label);\r\n  font-weight: 500;\r\n  letter-spacing: 0.4px;\r\n}\r\n\r\n.os-hero__title {\r\n  color: #ffffff;\r\n  font-weight: 900;\r\n  line-height: 1.05;\r\n  letter-spacing: -0.03em;\r\n  font-size: clamp(34px, 4vw, 60px);\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.os-hero__subtitle {\r\n  color: rgba(219, 234, 254, 1);\r\n  font-size: clamp(16px, 1.6vw, 20px);\r\n  line-height: 1.5;\r\n  max-width: 720px;\r\n  margin: 0;\r\n}\r\n\r\n/* ---------- STATS ---------- */\r\n.os-stats-wrap {\r\n  position: relative;\r\n  margin-top: -40px;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.os-stats {\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  box-shadow: 0 18px 40px rgba(13, 18, 27, 0.12);\r\n  padding: 22px 18px;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  overflow: hidden;\r\n}\r\n\r\n.os-stats--single {\r\n  grid-template-columns: 1fr;\r\n}\r\n\r\n.os-stat {\r\n  padding: 10px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.os-stats--single .os-stat {\r\n  max-width: 380px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.os-stat--mid {\r\n  border-left: 1px solid #e5e7eb;\r\n  border-right: 1px solid #e5e7eb;\r\n}\r\n\r\n.os-stat__iconWrap {\r\n  width: 46px;\r\n  height: 46px;\r\n  border-radius: 9999px;\r\n  display: grid;\r\n  place-items: center;\r\n  background: #eff6ff;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.os-stat__icon {\r\n  color: #370b3b;\r\n  font-size: 28px;\r\n}\r\n\r\n.os-stat__value {\r\n  font-weight: 900;\r\n  font-size: 36px;\r\n  margin: 0;\r\n}\r\n\r\n.os-stat__label {\r\n  color: #6b7280;\r\n  font-size: var(--os-type-label);\r\n  font-weight: 600;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ---------- SECTION HEADINGS ---------- */\r\n.os-h2 {\r\n  font-size: var(--os-type-heading);\r\n  font-weight: 800;\r\n  letter-spacing: -0.015em;\r\n  margin: 0 0 6px;\r\n}\r\n\r\n.os-h2--big {\r\n  font-size: clamp(28px, 2.6vw, 40px);\r\n}\r\n\r\n.os-muted {\r\n  color: #6b7280;\r\n  margin: 0;\r\n}\r\n\r\n.os-kicker {\r\n  color: #370b3b;\r\n  font-size: var(--os-type-label);\r\n  font-weight: 900;\r\n  letter-spacing: 0.14em;\r\n}\r\n\r\n/* ---------- PLACEHOLDER (for future images) ---------- */\r\n.os-placeholder {\r\n  background: #ece4ed;\r\n  border: 1px dashed #370b3b;\r\n  position: relative;\r\n}\r\n\r\n.os-placeholder__center {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: grid;\r\n  place-items: center;\r\n  gap: 6px;\r\n  color: #370b3b;\r\n  font-weight: 800;\r\n  opacity: 0.85;\r\n}\r\n\r\n.os-placeholder__center span.material-symbols-outlined {\r\n  font-size: 28px;\r\n}\r\n\r\n/* ---------- TOP PERFORMERS ---------- */\r\n.os-performers {\r\n  padding: 58px 0 30px;\r\n  background: #ece4ed;\r\n}\r\n\r\n.os-performers--muted {\r\n  opacity: 0.42;\r\n  filter: grayscale(0.15);\r\n  pointer-events: none;\r\n}\r\n\r\n.os-performers__head {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 18px;\r\n  margin-bottom: 26px;\r\n}\r\n\r\n.os-tabs {\r\n  display: inline-flex;\r\n  padding: 4px;\r\n  background: #d6c3d9;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 0 rgba(13, 18, 27, 0.04);\r\n}\r\n\r\n.os-tab {\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n  font-weight: 650;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  transition: all 160ms ease;\r\n}\r\n\r\n.os-tab:hover {\r\n  color: #370b3b;\r\n}\r\n\r\n.os-tab.is-active {\r\n  background: #370b3b;\r\n  color: #ffffff;\r\n  box-shadow: 0 6px 14px rgba(15, 73, 189, 0.25);\r\n}\r\n\r\n.os-cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 18px;\r\n}\r\n\r\n.os-card {\r\n  position: relative;\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  background: #ffffff;\r\n  border: 1px solid #eef2f7;\r\n  box-shadow: 0 2px 10px rgba(13, 18, 27, 0.05);\r\n  transition: transform 200ms ease, box-shadow 200ms ease;\r\n}\r\n\r\n.os-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);\r\n}\r\n\r\n.os-card--gold {\r\n  border: 1px solid #fcd34d;\r\n  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.15);\r\n}\r\n\r\n.os-card__badge {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  padding: 6px 10px;\r\n  font-size: 0.85rem;\r\n  font-weight: 800;\r\n  color: #ffffff;\r\n  border-bottom-left-radius: 10px;\r\n  z-index: 2;\r\n}\r\n\r\n.os-card__badge.is-primary {\r\n  background: #370b3b;\r\n}\r\n\r\n.os-card__badge.is-accent {\r\n  background: #f59e0b;\r\n}\r\n\r\n.os-card__imgWrap {\r\n  width: 100%;\r\n  height: 220px;\r\n  overflow: hidden;\r\n}\r\n\r\n.os-card__body {\r\n  padding: 14px 14px 16px;\r\n  text-align: center;\r\n}\r\n\r\n.os-card__name {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 800;\r\n}\r\n\r\n.os-card__meta {\r\n  margin-top: 4px;\r\n  color: #370b3b;\r\n  font-weight: 700;\r\n  font-size: var(--os-type-body);\r\n}\r\n\r\n.os-divider {\r\n  width: 100%;\r\n  height: 1px;\r\n  background: #eef2f7;\r\n  margin: 12px 0;\r\n}\r\n\r\n.os-card__tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  color: #f59e0b;\r\n}\r\n\r\n.os-star {\r\n  font-size: 16px;\r\n}\r\n\r\n.os-card__tagText {\r\n  font-size: 0.88rem;\r\n  font-weight: 800;\r\n  letter-spacing: 0.12em;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.os-center {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.os-linkBtn {\r\n  border: 0;\r\n  background: transparent;\r\n  color: #370b3b;\r\n  font-weight: 800;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  transition: gap 180ms ease;\r\n}\r\n\r\n.os-linkBtn:hover {\r\n  gap: 12px;\r\n}\r\n\r\n.os-linkBtn__icon {\r\n  font-size: 18px;\r\n}\r\n\r\n/* ---------- NEW: VIDEOS ROW SECTION ---------- */\r\n.os-videoRow {\r\n  padding: 34px 0 70px;\r\n  background: #ece4ed;\r\n}\r\n\r\n.os-videoRow__head {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.os-videoRow__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 18px;\r\n}\r\n\r\n.os-videoTile {\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  background: #0b1220;\r\n  box-shadow: 0 14px 26px rgba(13, 18, 27, 0.12);\r\n  cursor: pointer;\r\n  height: 280px;\r\n  position: relative;\r\n}\r\n\r\n.os-videoTile__iframeWrap {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.os-ytFrame {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n  display: block;\r\n}\r\n\r\n.os-videoTile__caption {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  padding: 14px;\r\n  color: #fff;\r\n  font-weight: 700;\r\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0));\r\n}\r\n\r\n/* ---------- Restored: Previously Mentored Students ---------- */\r\n.os-mentored {\r\n  background: #e0d8e2;\r\n  padding: 70px 0 84px;\r\n  border-top: 1px solid #eef2f7;\r\n}\r\n\r\n.os-mentored--muted {\r\n  opacity: 1;\r\n}\r\n\r\n.os-mentored__title {\r\n  text-align: center;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.os-mentored__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 18px;\r\n}\r\n\r\n.os-mentoredCard {\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  border: 1px solid #eef2f7;\r\n  box-shadow: 0 2px 12px rgba(13, 18, 27, 0.06);\r\n  overflow: hidden;\r\n  transition: transform 180ms ease, box-shadow 180ms ease;\r\n}\r\n\r\n.os-mentoredCard:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 18px 34px rgba(13, 18, 27, 0.12);\r\n}\r\n\r\n.os-mentoredCard__img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 210px;\r\n  object-fit: contain;\r\n  object-position: center;\r\n  image-rendering: -webkit-optimize-contrast;\r\n  image-rendering: crisp-edges;\r\n  background: #f8fafc;\r\n}\r\n\r\n.os-mentoredCard__text {\r\n  display: block;\r\n  width: 100%;\r\n  height: 140px;\r\n  object-fit: contain;\r\n  object-position: center;\r\n  image-rendering: -webkit-optimize-contrast;\r\n  image-rendering: crisp-edges;\r\n  border-top: 1px solid rgba(15, 73, 189, 0.12);\r\n  background: #f8fafc;\r\n}\r\n\r\n.os-mentoredCard__text--empty {\r\n  transform: none;\r\n}\r\n\r\n.os-mentoredCard__meta {\r\n  padding: 12px 14px 14px;\r\n  text-align: center;\r\n  background: #fff;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.os-mentoredCard__name {\r\n  font-weight: 900;\r\n  font-size: 22px;\r\n  line-height: 1.25;\r\n  color: #111827;\r\n}\r\n\r\n.os-mentoredCard__sub {\r\n  margin-top: 4px;\r\n  font-size: 0.95rem;\r\n  color: #6b7280;\r\n}\r\n\r\n/* ---------- NEW: You Will Be the Next ---------- */\r\n.os-next {\r\n  background: #e0d8e2;\r\n  padding: 70px 0 84px;\r\n  border-top: 1px solid #eef2f7;\r\n}\r\n\r\n.os-next__title {\r\n  text-align: center;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.os-next .os-kicker {\r\n  color: #5b1a65;\r\n  letter-spacing: 0.14em;\r\n}\r\n\r\n.os-next .os-h2 {\r\n  color: #2a0d33;\r\n}\r\n\r\n.os-next__line1 {\r\n  color: #370b3b !important;\r\n}\r\n\r\n.os-next__word-next {\r\n  color: red;\r\n}\r\n\r\n.os-next__tagline {\r\n  margin: 10px 0 0;\r\n  font-size: 22px;\r\n  font-weight: 900;\r\n  color: #370b3b;\r\n}\r\n\r\n.os-next__accent1 {\r\n  color: red;\r\n}\r\n\r\n.os-next__accent2 {\r\n  color: #370b3b;\r\n}\r\n\r\n.os-next__imageWrap {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.os-next__image {\r\n  width: min(300px, 90vw);\r\n  height: auto;\r\n  display: block;\r\n  border-radius: 14px;\r\n  box-shadow: 0 14px 32px rgba(13, 18, 27, 0.14);\r\n}\r\n\r\n/* ---------- ALUMNI ---------- */\r\n.os-alumni {\r\n  background: #f8f9fc;\r\n  border-top: 1px solid #e5e7eb;\r\n  padding: 56px 0;\r\n}\r\n\r\n.os-alumni__inner {\r\n  text-align: center;\r\n}\r\n\r\n.os-alumni__title {\r\n  margin: 0 0 20px;\r\n  color: #9ca3af;\r\n  font-size: var(--os-type-label);\r\n  font-weight: 900;\r\n  letter-spacing: 0.16em;\r\n}\r\n\r\n.os-alumni__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(6, 1fr);\r\n  gap: 12px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0.75;\r\n  filter: grayscale(1);\r\n  transition: filter 220ms ease, opacity 220ms ease;\r\n}\r\n\r\n.os-alumni__grid:hover {\r\n  filter: grayscale(0);\r\n  opacity: 1;\r\n}\r\n\r\n.os-alumni__pill {\r\n  height: 46px;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  border: 1px solid #eef2f7;\r\n  display: grid;\r\n  place-items: center;\r\n  font-weight: 800;\r\n  color: #6b7280;\r\n  box-shadow: 0 1px 8px rgba(13, 18, 27, 0.05);\r\n}\r\n\r\n/* ---------- CTA ---------- */\r\n.os-cta {\r\n  position: relative;\r\n  background: #370b3b;\r\n  padding: 76px 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.os-cta__shape {\r\n  position: absolute;\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.os-cta__shape--tr {\r\n  width: 260px;\r\n  height: 260px;\r\n  top: 0;\r\n  right: 0;\r\n  transform: translate(50%, -50%);\r\n}\r\n\r\n.os-cta__shape--bl {\r\n  width: 380px;\r\n  height: 380px;\r\n  bottom: 0;\r\n  left: 0;\r\n  transform: translate(-50%, 50%);\r\n}\r\n\r\n.os-cta__inner {\r\n  position: relative;\r\n  z-index: 1;\r\n  text-align: center;\r\n  width: min(800px, 100% - 48px);\r\n}\r\n\r\n.os-cta__title {\r\n  color: #fff;\r\n  font-weight: 900;\r\n  letter-spacing: -0.02em;\r\n  font-size: clamp(28px, 4vw, 52px);\r\n  margin: 0 0 14px;\r\n}\r\n\r\n.os-cta__sub {\r\n  color: rgba(219, 234, 254, 1);\r\n  font-size: 18px;\r\n  line-height: 1.6;\r\n  margin: 0 auto 22px;\r\n  max-width: 660px;\r\n}\r\n\r\n.os-cta__btns {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.os-btn {\r\n  border: 0;\r\n  padding: 14px 22px;\r\n  border-radius: 10px;\r\n  font-weight: 900;\r\n  cursor: pointer;\r\n  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;\r\n}\r\n\r\n.os-btn--white {\r\n  background: #ffffff;\r\n  color: #370b3b;\r\n  box-shadow: 0 14px 24px rgba(13, 18, 27, 0.18);\r\n}\r\n\r\n.os-btn--white:hover {\r\n  background: #f3f4f6;\r\n  color: #f59e0b;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.os-btn--outline {\r\n  background: transparent;\r\n  border: 2px solid #ffffff;\r\n  color: #ffffff;\r\n}\r\n\r\n.os-btn--outline:hover {\r\n  color: #f59e0b;\r\n}\r\n\r\n/* ---------- Responsive ---------- */\r\n@media (max-width: 1024px) {\r\n  .os-cards {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .os-videoRow__grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .os-videoTile {\r\n    height: 260px;\r\n  }\r\n\r\n  .os-mentored__grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .os-next__image {\r\n    width: min(420px, 88vw);\r\n  }\r\n\r\n  .os-alumni__grid {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 820px) {\r\n  .os-performers__head {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .os-stat--mid {\r\n    border-left: 0;\r\n    border-right: 0;\r\n  }\r\n\r\n  .os-stats {\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n  }\r\n\r\n  .os-stat {\r\n    border-top: 1px solid #e5e7eb;\r\n  }\r\n\r\n  .os-stat:first-child {\r\n    border-top: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .os-container {\r\n    width: min(1100px, 100% - 28px);\r\n  }\r\n\r\n  .os-cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .os-videoRow__grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .os-videoTile {\r\n    height: 240px;\r\n  }\r\n\r\n  .os-mentored__grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .os-next__tagline {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .os-next__image {\r\n    width: min(340px, 88vw);\r\n  }\r\n\r\n  .os-alumni__grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n/* ===== Featured centered video (16:9) ===== */\r\n.os-featuredVideo {\r\n  padding: 32px 0 8px;\r\n}\r\n\r\n.os-featuredVideo__frameWrap {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  aspect-ratio: 16 / 9;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);\r\n  background: #000;\r\n}\r\n\r\n.os-featuredVideo__frame {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n  display: block;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .os-featuredVideo {\r\n    padding: 20px 0 4px;\r\n  }\r\n  .os-featuredVideo__frameWrap {\r\n    border-radius: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
